import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'app-custom-face-capture',
	templateUrl: './custom-face-capture.component.html',
	styleUrls: ['./custom-face-capture.component.scss']
})
export class CustomFaceCaptureComponent implements OnInit {
	@Input() isMobile: boolean;
	@Output() nextStep = new EventEmitter();
	showCamera = false;

	constructor() {
	}

	ngOnInit(): void {
	}

	submitFaceCapture() {
		this.nextStep.emit();
	}

}
